/**
 * Mantine theme configuration
 * LostMind AI branding and design system
 */

import { createTheme } from '@mantine/core';

export const theme = createTheme({
  /** LostMind AI brand colors */
  colors: {
    'neural-blue': [
      '#f0f7ff',
      '#c7e4ff',
      '#94d0ff',
      '#61bcff',
      '#3aa8ff',
      '#1a94ff',
      '#1a365d', // Primary brand color
      '#0f2847',
      '#051a30',
      '#020d1a',
    ],
    'electric-cyan': [
      '#f0ffff',
      '#c7ffff',
      '#94ffff',
      '#61ffff',
      '#3affff',
      '#1affff',
      '#00d9ff', // Secondary brand color
      '#00bce6',
      '#009fcc',
      '#0082b3',
    ],
    'warm-gold': [
      '#fffef0',
      '#fffac7',
      '#fff694',
      '#fff261',
      '#ffee3a',
      '#ffea1a',
      '#ffd700', // Accent color
      '#e6c200',
      '#ccad00',
      '#b39900',
    ],
  },

  /** Primary color scheme */
  primaryColor: 'neural-blue',
  primaryShade: 6,

  /** Dark theme as default - configured in MantineProvider */

  /** Typography */
  fontFamily: 'Inter, system-ui, sans-serif',
  headings: {
    fontFamily: 'Inter, system-ui, sans-serif',
    fontWeight: '700',
  },

  /** Component customization */
  components: {
    Button: {
      defaultProps: {
        size: 'md',
        radius: 'md',
      },
    },
    Paper: {
      defaultProps: {
        radius: 'md',
        shadow: 'sm',
      },
    },
    Modal: {
      defaultProps: {
        centered: true,
        radius: 'md',
      },
    },
  },

  /** Spacing and sizing */
  spacing: {
    xs: '0.5rem',
    sm: '0.75rem',
    md: '1rem',
    lg: '1.5rem',
    xl: '2rem',
  },

  /** Border radius */
  radius: {
    xs: '0.25rem',
    sm: '0.375rem',
    md: '0.5rem',
    lg: '0.75rem',
    xl: '1rem',
  },
});